export class JtiDocumentAdditionalInfoForDate
{
  code: string;
  name: string;
  filter: string;
  required: boolean;
  valueRestriction: string;
  value: string;
}
